const colorArray = [
  {
    id: "#219653",
    textColor: "text-[#219653]",
    backgroundColor: "bg-[#d3eadd]",
    blockBg: "bg-[#219653]",
    border: "border-[#219653]",
  },
  {
    id: "#F2C94C",
    textColor: "text-[#F2C94C]",
    backgroundColor: "bg-[#FCF4DB]",
    blockBg: "bg-[#F2C94C]",
    border: "border-[#F2C94C]",
  },
  {
    id: "#F2994A",
    textColor: "text-[#F2994A]",
    backgroundColor: "bg-[#FFECCB]",
    blockBg: "bg-[#F2994A]",
    border: "border-[#F2994A]",
  },
  {
    id: "#EB5757",
    textColor: "text-[#EB5757]",
    backgroundColor: "bg-[#FFE5DA]",
    blockBg: "bg-[#EB5757]",
    border: "border-[#EB5757]",
  },
  {
    id: "#2F80ED",
    textColor: "text-[#2F80ED]",
    backgroundColor: "bg-[#D5E6FB]",
    blockBg: "bg-[#2F80ED]",
    border: "border-[#2F80ED]",
  },
  {
    id: "#56CCF2",
    textColor: "text-[#56CCF2]",
    backgroundColor: "bg-[#F2FFFF]",
    blockBg: "bg-[#56CCF2]",
    border: "border-[#56CCF2]",
  },
  {
    id: "#6FCF97",
    textColor: "text-[#6FCF97]",
    backgroundColor: "bg-[#E1FFFF]",
    blockBg: "bg-[#6FCF97]",
    border: "border-[#6FCF97]",
  },
  {
    id: "#333333",
    textColor: "text-[#333333]",
    backgroundColor: "bg-[#E6E6E6]",
    blockBg: "bg-[#333333]",
    border: "border-[#333333]",
  },
  {
    id: "#4F4F4F",
    textColor: "text-[#4F4F4F]",
    backgroundColor: "bg-[#EDEDED]",
    blockBg: "bg-[#4F4F4F]",
    border: "border-[#4F4F4F]",
  },
  {
    id: "#828282",
    textColor: "text-[#828282]",
    backgroundColor: "bg-[#EFEFEF]",
    blockBg: "bg-[#828282]",
    border: "border-[#828282]",
  },
  {
    id: "#BDBDBD",
    textColor: "text-[#BDBDBD]",
    backgroundColor: "bg-[#F5F5F5]",
    blockBg: "bg-[#BDBDBD]",
    border: "border-[#BDBDBD]",
  },
  {
    id: "#E0E0E0",
    textColor: "text-[#E0E0E0]",
    backgroundColor: "bg-[#FDFDFD]",
    blockBg: "bg-[#E0E0E0]",
    border: "border-[#E0E0E0]",
  },
];

export default colorArray;
